import PropTypes from "prop-types";
import { Step, StepContent, StepLabel, Stepper } from "@mui/material";

const CustomStepper = ({ className = "", steps, activeStep, orientation, alternativeLabel }) => {
  return (
    <Stepper
      className={`custom-stepper${!!className ? ` ${className}` : ""}`}
      activeStep={activeStep}
      orientation={orientation}
      alternativeLabel={alternativeLabel}
    >
      {steps.map(({ label, subComponent, StepComponent }, idx) => {
        const isActive = idx + 1 === activeStep;
        return (
          <Step
            key={idx}
            className={`${isActive ? "active" : ""}`}
            expanded={true}
            completed={idx < activeStep}
            aria-current={isActive ? "step" : undefined}
          >
            <StepLabel StepIconComponent={StepComponent}>{label}</StepLabel>
            {!!subComponent && (
              <StepContent slotProps={{ transition: { unmountOnExit: false } }}>{subComponent}</StepContent>
            )}
          </Step>
        );
      })}
    </Stepper>
  );
};

CustomStepper.prototype = {
  className: PropTypes.string,
  steps: PropTypes.array,
  activeStep: PropTypes.number,
  orientation: PropTypes.string,
  alternativeLabel: PropTypes.bool,
};

export default CustomStepper;
